<div
  class="bg-background-500 w-screen pt-[60px] h-screen m-auto flex flex-col justify-center items-center gap-[15px]">
  <div class="w-40 desktop:w-auto">
    <img
      [src]="isRateLimit ? 'icons/message_time.svg' : 'icons/message_error.svg'"
      width="275px"
      height="260px"
      alt="" />
  </div>
  @if (isRateLimit) {
    <div
      class="text-center max-w-[249px] desktop:max-w-[350px] h-[110px] flex flex-col gap-[15px]"
      role="status">
      <h3 class="text-xl text-info-600 font-bold">
        Un momento, por favor
      </h3>
      <p class="text-sm text-primary-800 font-medium">
        Por favor, intentá de nuevo en unos segundos.
      </p>
    </div>
  } @else {
    <div
      class="text-center max-w-[249px] desktop:max-w-[350px] h-[110px] flex flex-col gap-[15px]">
      <h3 class="text-xl text-danger-600 font-bold">
        Estamos teniendo problemas
      </h3>
      <p class="text-sm text-primary-800 font-medium">
        Por favor, vuelve a intentarlo
      </p>
    </div>
  }
  <div class="mt-4 desktop:mt-0 flex flex-col desktop:flex-row gap-[15px]">
    @if (isResultsPage) {
      <app-button
        color="Primary"
        text="VOLVER ATRAS"
        size="Large"
        [width]="217"
        (buttonClick)="onClickPrimary($event)" />
    }
    <app-button
      color="Secondary"
      [text]="retryText"
      size="Large"
      [width]="217"
      [disabled]="secondsLeft > 0"
      (buttonClick)="onClickSecondary($event)" />
  </div>
</div>
